import CBSearchTextFieldController from "../controller/CBSearchTextFieldController";

const CBTaxCodeSearchFilter = () => {

    return (
        <CBSearchTextFieldController
            idField="taxCode"
            formName="taxCode"
            label="taxCode"
            inputProps={{maxLength: 16, style: {textTransform: "uppercase"}}}
        />
    )
}

export default CBTaxCodeSearchFilter;